import React from 'react';
import { Routing } from './routing/routing';

const App: React.FC = () => {
  return (
    <div className="App" style={{ position: "relative" }}>
      <Routing/>
    </div>
  )
}

export default App;
